export default "__VITE_ASSET__9066b7da__"